// extracted by mini-css-extract-plugin
export default {"root":"_3272G","body-wrapper":"_1JjxC","bodyWrapper":"_1JjxC","big":"_3U8hI","postfix":"_1Az0W","small":"_3ERpe","body-node":"_2M0HH","bodyNode":"_2M0HH"};